import { deleteField } from "firebase/firestore";
import _ from 'lodash';
import { _dateKeys, _ignoreKeys, dataFix } from "../../../../../global/common/dataFix";
import { removeFromObject, removeFromObjects, sumObjectProp } from "../../../../../global/common/sorting";
import { createRefPath, createRefPath_event } from '../../../../../global/firestoreData/appData/appRefPaths';
import { golfEnums } from "projectSpecific/golf/enums/golfEnums";
import { calcGolferHoleWinners, calcGolferPartnersAndOpponents, calcMatchStatus } from "../../../golfCalcs/calcMatchStatus";
import { getMatchHandicap } from "projectSpecific/golf/removed/createGolfRoundMatches";
import { calcGolfRounds } from "projectSpecific/golf/golfCalcs/calcGolfRounds";
import { _allowGolfEventUpdates } from "../GolfEventReducer";

const _golfTournamentCollection = 'golfTournaments'
const _golfTournamenCollection_details = 'details'
const _golfTournamentDocument_details = 'details'
const _golfTournamentDocument_matches = 'matches'

const removeFields_golferMatch = [
  '_authData',
  '_dateProps',
  '_existingKey',
  '_updateDate',
  'auth_uid',
  'courseHandicap',
  'courseHandicaps',
  'courseTeeboxes',
  'email',
  'firstName',
  'handicapIndex',
  'handicapSourceType',
  'id',
  'itemKey',
  'key',
  'lastName',
  'matchHandicap',
  'name',
  'previousHandicapIndexes',
  'shortName',
  'tournamentHandicapIndex',
  'tournamentHandicapSourceType',
]

const initGolfTournamentData = (state, golfEvent_state) => {

  const { golfTournament, golfCourse, matches, details, tournamentGolfCourses } = state
  const { rounds, teams, golfers: golfers_tournament, lineups } = details

  const matches_golfTournament = getAllMatches_golf(rounds, matches)

  const { teams: teams_event, golfers: golfers_event, golfers_auth, allGolfers, golfCourses } = golfEvent_state ?? {}

  if (rounds && golfCourses) {
    Object.keys(rounds).forEach(rk => {
      const round = rounds[rk]
      if (round.golfCourse) {
        const rgc = golfCourses[round.golfCourse]
        if (rgc) {
          round.golfCourseName = rgc.name
        }
      }
    })
  }

  const { description } = golfTournament ?? {}
  let { holes, teeBoxes } = golfCourse ? golfCourse : {}

  if (!holes) {
    holes = _.fromPairs(
      _.map(_.range(1, 19), (i) => [
        i,
        { holeNumber: i, par: 4, handicap: i }
      ])
    );
  }

  let golfCoursePar = holes ? sumObjectProp(holes, 'par') : 72
  const missing = {}

  const _golfers = ammendTournamentGolfers(golfers_event, golfers_tournament, golfers_auth)

  ammendMatchGolfers(matches_golfTournament, _golfers, allGolfers, tournamentGolfCourses, rounds, missing, golfers_auth)
  ammendLineupsWithGolfers(lineups, _golfers)

  const golfTeam1_event = teams_event ? teams_event.team1 : {}
  const golfTeam2_event = teams_event ? teams_event.team2 : {}

  const golfTeam1 = teams ? _.find(teams, { teamNumber: 1 }) : {}
  const golfTeam2 = teams ? _.find(teams, { teamNumber: 2 }) : {}

  const golfTeam_1 = teams ? _.find(teams, { teamNumber: '1' }) : {}
  const golfTeam_2 = teams ? _.find(teams, { teamNumber: '2' }) : {}

  const _golfTeam1 = golfTeam1 ? golfTeam1 : golfTeam_1
  const _golfTeam2 = golfTeam2 ? golfTeam2 : golfTeam_2

  const golfClasses = {
    active: 'status-active',
    completed: 'status-completed',
    default: 'status-default',
    neutral: 'status-neutral',
    pending: 'status-pending',
  }

  const activeStyle = { backgroundColor: 'green', color: 'white' }
  const completedStyle = { backgroundColor: '#575757', color: 'white' }
  const defaultStyle = { backgroundColor: 'darkgrey', color: 'white' }
  const noneStyle = { backgroundColor: 'darkgrey', color: 'white' }
  const neutralStyle = { backgroundColor: 'darkGrey', color: 'black' }
  const tieStyle = { backgroundColor: 'grey', color: 'black' }
  const pendingStyle = { backgroundColor: '#6e6e6e', color: 'white' }
  const removeStyle = { backgroundColor: '#ff9e81' }
  const secondaryStyle = { backgroundColor: '#606060ff', color: 'white' }

  const roundColors = {
    [golfEnums.roundTypes.neutral]: roundColor(golfEnums.roundTypes.neutral),

    [golfEnums.roundTypes.alternateShot]: roundColor(golfEnums.roundTypes.alternateShot),
    [golfEnums.roundTypes.alternateShot1]: roundColor(golfEnums.roundTypes.alternateShot1),
    [golfEnums.roundTypes.alternateShot2]: roundColor(golfEnums.roundTypes.alternateShot2),

    [golfEnums.roundTypes.bestBall]: roundColor(golfEnums.roundTypes.bestBall),
    [golfEnums.roundTypes.bestBall1]: roundColor(golfEnums.roundTypes.bestBall1),
    [golfEnums.roundTypes.bestBall2]: roundColor(golfEnums.roundTypes.bestBall2),

    [golfEnums.roundTypes.singles]: roundColor(golfEnums.roundTypes.singles),
    [golfEnums.roundTypes.scramble]: roundColor(golfEnums.roundTypes.scramble),
  }

  const golfTeam1Style = {
    backgroundColor: golfTeam1_event && golfTeam1_event.teamColor ? golfTeam1_event.teamColor : 'white',
    color: golfTeam1_event && golfTeam1_event.teamTextColor ? golfTeam1_event.teamTextColor : 'black',
  }

  const golfTeam2Style = {
    backgroundColor: golfTeam2_event && golfTeam2_event.teamColor ? golfTeam2_event.teamColor : 'white',
    color: golfTeam2_event && golfTeam2_event.teamTextColor ? golfTeam2_event.teamTextColor : 'black',
  }

  let matches_rounds = {}
  let roundsStatus = {}
  let roundsStatusByHole = {}

  const ts = {
    team1Leading: 0,
    team1Virtual: 0,
    team1Wins: 0,
    team1Dormies: 0,
    team1Halved: 0,
    team1Square: 0,
    team2Leading: 0,
    team2Virtual: 0,
    team2Wins: 0,
    team2Dormies: 0,
    team2Halved: 0,
    team2Square: 0,
    matchesSquare: 0,
    matchesHalved: 0,
    tournamentComplete: true
  }

  if (rounds) {
    const { matches_rounds: _roundsMatches, roundsStatus: _roundsStatus, roundsStatusByHole: _roundsStatusByHole } = calcGolfRounds(ts, golfTournament, rounds, matches, holes, teams)
    matches_rounds = _roundsMatches
    roundsStatus = _roundsStatus
    roundsStatusByHole = _roundsStatusByHole
    if (roundsStatus) {
      Object.keys(roundsStatus).forEach(key => {
        const rs = roundsStatus[key]
        if (!rs.roundComplete) {
          ts.tournamentComplete = false
        }
      })
    } else {
      ts.tournamentComplete = false
    }
  } else {
    ts.tournamentComplete = false
  }

  const gts = {
    matchDataIsLocked: golfTournament.dataIsLocked,
    description,
    golfCourse,
    golfCoursePar,
    // golfCourseTeeBox,
    matches,
    matches_golfTournament,
    golfers: _golfers,
    golfTeam1: _golfTeam1,
    golfClasses: golfClasses,
    golfStyles: {
      activeStyle,
      completedStyle,
      defaultStyle,
      golfTeam1Style,
      golfTeam2Style,
      neutralStyle,
      noneStyle,
      pendingStyle,
      roundColors,
      removeStyle,
      secondaryStyle,
      tieStyle,
    },
    golfTeam2: _golfTeam2,
    golfTournament,
    holes,
    teams,
    teeBoxes,
    lineups,
    matches_rounds,
    roundsStatus,
    roundsStatusByHole,
    rounds,
    tournamentStatus: ts,
  }

  return gts
}


const getAllMatches_golf = (rounds, matches) => {
  let _matches = {}
  if (rounds && matches) {
    Object.keys(rounds).forEach(roundKey => {
      if (matches[roundKey]) {
        _matches = { ..._matches, ...matches[roundKey] }
      }
    })
  }
  return _matches
}

const getTournamentCourses = (state) => {
  const { details, golfEvent_state } = state ?? {}
  const { golfCourses: golfCourses_all } = golfEvent_state ?? {}
  const { rounds } = details ?? {}

  if (golfCourses_all && rounds) {
    const _golfCourses = {}
    Object.keys(rounds).forEach(key => {
      const round = rounds[key]
      const { golfCourse } = round ? round : {}
      if (golfCourse && golfCourses_all[golfCourse]) {
        _golfCourses[golfCourse] = golfCourses_all[golfCourse]
      }
    })
    return _golfCourses
  }
}

const ammendTournamentGolfers = (golfers_event, golfers_tournament, golfers_auth) => {

  const golfers = {}

  if (golfers_event && golfers_tournament) {
    // loop the golfers in the tournament
    Object.keys(golfers_tournament).forEach(gk => {
      const golfer_event = golfers_event[gk]
      const golfer_tournament = golfers_tournament[gk]
      if (golfer_event) {
        const { firstName, lastName, handicapSourceType, handicapIndex, _dateProps } = golfer_event
        golfer_tournament._itemKey = gk
        golfer_tournament.handicapIndex = handicapIndex
        golfer_tournament.handicapSourceType = handicapSourceType
        golfer_tournament._dateProps = _dateProps
        golfer_tournament.firstName = firstName
        golfer_tournament.lastName = lastName
        golfer_tournament.name = firstName + ' ' + lastName
        golfer_tournament.shortName = getShortName(golfer_tournament)
        if (golfers_auth && golfers_auth[gk]) { golfer_tournament._authData = golfers_auth[gk] }
        removeFromObject(golfer_tournament, ['oldKey', 'tournamentTeams', 'handicap'])
        golfers[gk] = golfer_tournament
      }
    })
    return golfers
  }
}

const ammendMatchTeamGolfers = (match, teamGolfers, golfers, allGolfers, missing, golfers_auth) => {

  if (teamGolfers) {

    _.forEach(teamGolfers, (glf, gk) => {
      let golfer = golfers[gk]
      if (!golfer) {
        if (allGolfers && allGolfers?.[glf.oldKey]) {
          golfer = allGolfers?.[glf.oldKey]
          missing[gk] = glf
        }
      }

      if (golfer) {

        const { round: roundType } = match

        glf.firstName = golfer.firstName
        glf.lastName = golfer.lastName
        glf.name = golfer.name
        glf.courseHandicaps = golfer.courseHandicaps
        glf.courseHandicapIndexes = golfer.courseHandicapIndexes
        glf.courseTeeboxes = golfer.courseTeeboxes
        glf.allowLineupModification = golfer.allowLineupModification
        glf.courseTeebox = golfer.courseTeeboxes ? Object.values(golfer.courseTeeboxes)[0] : null
        glf.courseHandicap = golfer.courseHandicaps ? Object.values(golfer.courseHandicaps)[0] : null
        glf.courseHandicapIndex = golfer.courseHandicapIndexes ? Object.values(golfer.courseHandicapIndexes)[0] : null
        glf.tournamentHandicapIndex = golfer.tournamentHandicapIndex
        glf.matchHandicap = getMatchHandicap(glf.courseHandicap, glf.courseHandicapIndex, roundType, glf)
        glf.shortName = getShortName(glf)
        if (golfers_auth && golfers_auth[gk]) { glf._authData = golfers_auth[gk] }

        removeFromObject(glf, ['oldKey', 'tournamentTeams', 'handicap'])

      }
    })
  }
}

const ammendMatchGolfers = (matches_golfTournament, golfers, allGolfers, missing, golfers_auth) => {
  Object.keys(matches_golfTournament).forEach(k1 => {
    const match = matches_golfTournament[k1]
    const { team1, team2 } = match ?? {}
    ammendMatchTeamGolfers(match, team1, golfers, allGolfers, missing, golfers_auth)
    ammendMatchTeamGolfers(match, team2, golfers, allGolfers, missing, golfers_auth)
  })
}

/**
 * Add additional information about the golfer into the lineups
 * @param {object} lineups 
 * @param {object} golfers 
 */
const ammendLineupsWithGolfers = (lineups, golfers) => {
  if (lineups) {
    Object.keys(lineups).forEach(teamKey => {
      const teamLineups = lineups[teamKey]
      Object.keys(teamLineups).forEach(tlKey => {
        const teamLineup = teamLineups[tlKey]
        if (_.isArray(teamLineup)) {
          teamLineup.forEach(golfer => {
            const golfer_event = golfers[golfer.golferKey]
            const { firstName, lastName, name, courseHandicaps, courseTeeboxes, teebox } = golfer_event ? golfer_event : {}
            golfer.key = golfer.golferKey
            golfer.firstName = firstName
            golfer.lastName = lastName
            golfer.name = name
            golfer.courseHandicaps = courseHandicaps
            golfer.courseTeeboxes = courseTeeboxes
            golfer.teebox = teebox
          })
        } else {
          const { golfers } = teamLineup ? teamLineup : {}
          if (golfers) {
            Object.keys(golfers).forEach(gKey => {
              const g = golfers[gKey]
              g.key = gKey
            })
          }
        }
      })
    })
  }
}

const getSeletedTeamGolfers = (selectedLineupItems, golfers_lineup, golfers_team) => {
  const _selectedTeamGolfers = {}
  if (selectedLineupItems) {
    if (golfers_lineup) {
      selectedLineupItems.forEach(key => {
        const fg = _.find(golfers_lineup, { golferKey: key })
        if (fg) {
          _selectedTeamGolfers[key] = fg
        }
      })
    } else if (golfers_team) {
      selectedLineupItems.forEach(key => {
        if (golfers_team[key]) {
          _selectedTeamGolfers[key] = golfers_team[key]
        }
      })
    }
  }
  return _selectedTeamGolfers
}

const getPar = (holes) => {
  let _par = 0
  if (holes) {
    Object.keys(holes).forEach(hKey => {
      _par += parseInt(holes[hKey].par)
    })
  }
  return _par
}

const roundColor = (roundType) => {
  switch (roundType) {
    case golfEnums.roundTypes.singles:
      return '#65c031'
    case golfEnums.roundTypes.alternateShot:
    case golfEnums.roundTypes.alternateShot1:
    case golfEnums.roundTypes.alternateShot2:
      return '#e08f06'
    case golfEnums.roundTypes.neutral:
      return '#202020'
    default:
      return '#57a7fd'
  }
}

const getShortName = (glf) => {
  const { firstName, lastName } = glf
  return firstName.substring(0, 1) + '. ' + lastName
}

const ammendTournament_matchesStatus = (state, matches) => {
  const missing = {}
  const { golfTournament, golfCourse, details, golfEvent_state } = state
  const { rounds, teams, golfers: golfers_tournament, lineups } = details

  const { teams: teams_event, golfers: golfers_event, golfers_auth, allGolfers } = golfEvent_state ?? {}

  const matches_golfTournament = getAllMatches_golf(rounds, matches)

  let { holes } = golfCourse ? golfCourse : {}

  const _golfers = ammendTournamentGolfers(golfers_event, golfers_tournament, golfers_auth)

  ammendMatchGolfers(matches_golfTournament, _golfers, allGolfers, missing, golfers_auth)
  ammendLineupsWithGolfers(lineups, _golfers)

  let matches_rounds = {}
  let roundsStatus = {}
  let roundsStatusByHole = {}

  const ts = {
    team1Leading: 0,
    team1Virtual: 0,
    team1Wins: 0,
    team1Dormies: 0,
    team1Halved: 0,
    team1Square: 0,
    team2Leading: 0,
    team2Virtual: 0,
    team2Wins: 0,
    team2Dormies: 0,
    team2Halved: 0,
    team2Square: 0,
    matchesSquare: 0,
    matchesHalved: 0,
    tournamentComplete: true
  }

  if (rounds) {
    const { matches_rounds: _roundsMatches, roundsStatus: _roundsStatus, roundsStatusByHole: _roundsStatusByHole } = calcGolfRounds(ts, golfTournament, rounds, matches, holes, teams)
    matches_rounds = _roundsMatches
    roundsStatus = _roundsStatus
    roundsStatusByHole = _roundsStatusByHole
    if (roundsStatus) {
      _.forEach(roundsStatus, (rs, rsKey) => {
        if (!rs.roundComplete) {
          ts.tournamentComplete = false
        }
      })
    } else {
      ts.tournamentComplete = false
    }
  } else {
    ts.tournamentComplete = false
  }

  return { ts, roundsStatus, matches_rounds, matches_golfTournament }
}

/** Get the details */
const getGolfTournamentWithDetails = async (database_fns, gtid, pathViews, callbacks, golfTournament) => {

  let results = {};

  const _basePath = createRefPath_event(pathViews, [_golfTournamentCollection, gtid])

  const subRefs = {
    main: createRefPath_event(pathViews, [_golfTournamentCollection, gtid]),
    details: createRefPath([_golfTournamenCollection_details, _golfTournamentDocument_details], _basePath),
    matches: createRefPath([_golfTournamentDocument_matches], _basePath),
    info: createRefPath([_golfTournamenCollection_details, 'info'], _basePath),
  }

  const tryFinish = () => {
    let done = true
    _.forEach(subRefs, (sb, key) => {
      if (!results[key]) {
        done = false
      }
    })
    if (done) {
      // callbacks.main(results.main) 
      callbacks.details({ mainData: results.main, details: results.details, _details: global.structuredClone(results.details) })
      callbacks.matches(results.matches)
      // callbacks.info(results.info)
    }
  };

  const cb_all = (name, res) => {
    results[name] = res ? res : {}
    tryFinish()
  }

  if (golfTournament) {
    const _golfTournament = _.cloneDeep(golfTournament)
    const { details } = _golfTournament
    delete _golfTournament.details
    const mainData = _golfTournament
    const _details = details ? global.structuredClone(details) : {}
    detailsCallback({ mainData, details, _details })
    return
  }

  database_fns.get_data({ refPath: subRefs.main, callback: data => cb_all(_.keys(subRefs)[0], data), opts: { returnFirstObject: true, listen: true } })
  database_fns.get_data({ refPath: subRefs.details, callback: data => cb_all(_.keys(subRefs)[1], data), opts: { returnFirstObject: true, ignoreId: true, listen: true } })
  database_fns.get_data({ refPath: subRefs.matches, callback: data => cb_all(_.keys(subRefs)[2], data), opts: { ignoreId: true, listen: true } })
  database_fns.get_data({ refPath: subRefs.info, callback: data => cb_all(_.keys(subRefs)[3], data), opts: { returnFirstObject: true } })
}

const updateGolfTournament = async (database_fns, gtid, pathViews, dataToUpdate, callback) => {

  const _basePath = createRefPath_event(pathViews, [_golfTournamentCollection, gtid])

  if (_allowGolfEventUpdates.any && _allowGolfEventUpdates.tournamentResults) {
    // await database_fns.update_doc(_basePath, dataToUpdate)
    await database_fns.update_docc({
      refPath: _basePath,
      data: dataToUpdate,
    })
    callback && callback()
    //  database_fns.set_doc(_basePath, dataToUpdate, true, callback)
  } else {
    console.log('_basePath', _basePath)
    console.log('dataToUpdate', dataToUpdate)
    callback && callback({ _basePath, dataToUpdate })
  }
}


const updateGolfTournamentResults = async (database_fns, gtid, pathViews, dataToUpdate, callback) => {

  const _basePath = createRefPath_event(pathViews, [_golfTournamentCollection, gtid])

  if (_allowGolfEventUpdates.any && _allowGolfEventUpdates.tournamentResults) {
    // await database_fns.update_doc(_basePath, dataToUpdate)
    await database_fns.update_docc({
      refPath: _basePath,
      data: dataToUpdate,
    })
    callback && callback()
    //  database_fns.set_doc(_basePath, dataToUpdate, true, callback)
  } else {
    console.log('_basePath', _basePath)
    console.log('dataToUpdate', dataToUpdate)
    callback && callback({ _basePath, dataToUpdate })
  }
}

/** Updates the details */

/**
 * database_fns.update_doc(details/details)
 * @param {string} gtid 
 * @param {object} pathViews 
 * @param {object} dataToUpdate 
 * @param {function} callback 
 */
const updateGolfTournamentDetails = async (database_fns, gtid, pathViews, dataToUpdate, callback) => {

  const _basePath = createRefPath_event(pathViews, [_golfTournamentCollection, gtid, _golfTournamenCollection_details, _golfTournamentDocument_details])

  if (_allowGolfEventUpdates.any && _allowGolfEventUpdates.detailsUpdate) {
    // await database_fns.update_doc(_basePath, dataToUpdate)
    await database_fns.update_docc({
      refPath: _basePath,
      data: dataToUpdate,
    })
    callback && callback()
    //  database_fns.set_doc(_basePath, dataToUpdate, true, callback)
  } else {
    console.log('_basePath', _basePath)
    console.log('dataToUpdate', dataToUpdate)
    callback && callback({ _basePath, dataToUpdate })
  }
}

/** Updates the match score */

/**
 * 
 * @param {string} gtid 
 * @param {object} pathViews 
 * @param {object} matchData 
 * @param {function} callback 
 */
const updateMatchScore = (database_fns, gtid, pathViews, matchData, callback) => {

  const { round, holeWinners, holeScores, id } = matchData

  if (holeWinners) {
    Object.keys(holeWinners).forEach(k => {
      if (holeWinners[k].winningTeam === -1) {
        holeWinners[k] = deleteField()
      }
    })
  }

  const dataToUpdate = {
    [id]: { 'holeWinners': holeWinners }
  }

  if (holeScores) {
    dataToUpdate[id].holeScores = holeScores
  }

  const _basePath = createRefPath_event(pathViews, [_golfTournamentCollection, gtid, _golfTournamentDocument_matches, round])

  if (_allowGolfEventUpdates.any && _allowGolfEventUpdates.roundMatchUpdate) {
    database_fns.set_doc(_basePath, dataToUpdate, true, callback)
  } else {
    console.log('_basePath', _basePath)
    console.log('dataToUpdate', dataToUpdate)
    callback && callback({ _basePath, dataToUpdate })
  }
}

const removeMatchScore = (database_fns, gtid, pathViews, matchData, holeNumber, callback) => {

  const { round, holeScores, id } = matchData

  const dataToUpdate = {
    [id]: {
      'holeWinners': {
        [holeNumber]: deleteField()
      },
    }
  }

  if (holeScores) {
    dataToUpdate[id].holeScores = holeScores
  }

  const _basePath = createRefPath_event(pathViews, [_golfTournamentCollection, gtid, _golfTournamentDocument_matches, round])

  if (_allowGolfEventUpdates.any && _allowGolfEventUpdates.roundMatchUpdate) {
    database_fns.set_doc(_basePath, dataToUpdate, true, callback)
  } else {
    console.log('_basePath', _basePath)
    console.log('dataToUpdate', dataToUpdate)
    callback && callback({ _basePath, dataToUpdate })
  }

}

/** Creates the matches */
const createRoundMatchesInDatabase = async (database_fns, gtid, pathViews, matches, roundKey, callback, testOnly) => {

  const _basePath = createRefPath_event(pathViews, [_golfTournamentCollection, gtid, _golfTournamentDocument_matches, roundKey])

  let _matches = {}

  if (matches) {
    if (callback) {
      Object.keys(matches).forEach((key, index) => {
        const match = matches[key]
        delete match.lowCourseHandicap
        delete match.matchHandicaps
        const { team1, team2 } = match ?? {}
        removeFromObjects(team1, removeFields_golferMatch)
        removeFromObjects(team2, removeFields_golferMatch)
        const matchId = 'match_' + roundKey + '_' + (index + 1)
        _matches[matchId] = {
          ...match,
          id: matchId
        }
      })
    } else {
      _matches = matches
    }

    const dataToUpdate = { ..._matches }

    if (_allowGolfEventUpdates.any && _allowGolfEventUpdates.roundMatchCreate && !testOnly) {
      // delete the data first 
      await database_fns.delete_doc(_basePath)
      database_fns.set_doc(_basePath, dataToUpdate, true, callback)
    } else {
      console.log('_basePath', _basePath)
      console.log('dataToUpdate', dataToUpdate)
      callback && callback({ _basePath, dataToUpdate })
    }
  }
}

const clearTournamentResultsInDatabase = async (database_fns, gtid, golfTournament, pathViews, callback) => {

  const dataToUpdate = _.cloneDeep(golfTournament)

  dataToUpdate.results = deleteField()

  const refPath = createRefPath_event(pathViews, [_golfTournamentCollection, gtid])
  if (_allowGolfEventUpdates.any && _allowGolfEventUpdates.roundResultsClear) {
    database_fns.doc_update(refPath, dataToUpdate)
  } else {
    console.log('clearRoundResultsInDatabase2', refPath)
    console.log('dataToUpdate', dataToUpdate)
    callback && callback({ refPath, dataToUpdate })
  }
}

/** Clear the matches */
const clearRoundMatchesInDatabase = async (database_fns, gtid, pathViews, roundKey, callback) => {

  const _basePath = createRefPath_event(pathViews, [_golfTournamentCollection, gtid, _golfTournamentDocument_matches, roundKey])

  if (_allowGolfEventUpdates.any && _allowGolfEventUpdates.roundMatchClear) {
    await database_fns.delete_doc(_basePath, callback)
  } else {
    console.log('delete _basePath', _basePath)
    callback && callback({ _basePath })
  }
}

const clearRoundResultsInDatabase = async (database_fns, gtid, pathViews, roundKey, matches_round, callback) => {

  const dataToUpdate = {}

  _.forEach(matches_round, (m, mk) => {
    dataToUpdate[`${mk}.holeWinners`] = deleteField()
  })

  const refPath = createRefPath_event(pathViews, [_golfTournamentCollection, gtid, _golfTournamentDocument_matches, roundKey])
  if (_allowGolfEventUpdates.any && _allowGolfEventUpdates.roundResultsClear) {
    await database_fns.doc_update(refPath, dataToUpdate)
    callback && callback({ refPath, dataToUpdate })
  } else {
    console.log('clearRoundResultsInDatabase2', refPath)
    console.log('dataToUpdate', dataToUpdate)
    callback && callback({ refPath, dataToUpdate })
  }
}

const changeTournanemtGolfer = (action, state) => {

  const { existingGolferKey, newGolfer } = action
  const { _details } = state
  const { lineups, golfers } = _details

  const existingGolfer = golfers ? golfers[existingGolferKey] : {}
  const { teamNumber } = existingGolfer ? existingGolfer : 0
  newGolfer.teamNumber = teamNumber

  // change in lineups
  if (lineups) {
    Object.keys(lineups).forEach(lik => {
      const lineupTeam = lineups[lik]
      if (lineupTeam) {
        Object.keys(lineupTeam).forEach(k => {
          const lineupRound = lineupTeam[k]
          const existingGolfer = _.find(lineupRound, { 'golferKey': existingGolferKey })
          if (existingGolfer) {
            existingGolfer.golferKey = newGolfer._itemKey
          }
        })
      }
    })
  }

  delete golfers[existingGolferKey]
  golfers[newGolfer._itemKey] = newGolfer
  return { lineups, golfers }

}

const getGolferResults = (state) => {

  const golferRecords = {}
  let golferRecordsSorted = []

  const { matches, details } = state
  const { golfers } = details ?? {}

  if (matches && golfers) {
    const golferRoundMatches = {}
    _.forEach(golfers, (golfer, golferKey) => {
      _.forEach(matches, (matches_byRound, roundKey) => {
        _.forEach(matches_byRound, (roundMatch, roundMatchKey) => {
          const { team1, team2 } = roundMatch ?? {}
          if (team1?.[golferKey] || team2?.[golferKey]) {
            if (!golferRoundMatches[golferKey]) { golferRoundMatches[golferKey] = {} }
            golferRoundMatches[golferKey][roundMatchKey] = roundMatch
          }
        })
      })
    })

    if (golferRoundMatches && state.golfers) {
      _.forEach(golferRoundMatches, (_golferRoundMatches, gmsk) => {
        const golfer = state.golfers[gmsk]
        const { teamNumber, firstName, lastName, _itemKey } = golfer ?? {}

        golferRecords[gmsk] = {
          _itemKey,
          firstName,
          lastName,
          wins: 0,
          losses: 0,
          ties: 0,
          holes: {
            wins: 0,
            losses: 0,
            ties: 0,
          },
          partners: {},
          opponents: {}
        }

        _.forEach(_golferRoundMatches, (gm) => {
          const { wins, losses, ties } = calcGolferHoleWinners(gm, golfer)
          const mst = calcMatchStatus(gm, state.golfCourse.holes, state.teams, null, true)
          const { finished, winner } = mst

          if (finished) {
            if (winner === teamNumber) {
              golferRecords[gmsk].wins += 1
            } else if (!winner) {
              golferRecords[gmsk].ties += 1
            } else {
              golferRecords[gmsk].losses += 1
            }
          }

          golferRecords[gmsk].holes.wins += wins
          golferRecords[gmsk].holes.ties += ties
          golferRecords[gmsk].holes.losses += losses

          const { opps: opponents_match, pps: partners_match } = calcGolferPartnersAndOpponents(gm, golfer, golfers, mst)

          const partnerMatch = _.values(partners_match)[0]
          const partnerKey = _.keys(partners_match)[0]
          const { matchStatuses, rounds } = partnerMatch ?? {}
          const matchStatus = matchStatuses?.[0]
          const round = rounds?.[0]
          const { winner: winner_ms, finalScore } = matchStatus ?? {}

          if (partnerKey) {
            // Ensure golfer entry exists
            if (!golferRecords[gmsk]) {
              golferRecords[gmsk] = { partners: {} }
            }

            // Ensure partners object exists
            if (!golferRecords[gmsk].partners) {
              golferRecords[gmsk].partners = {}
            }

            // Ensure partner object exists
            if (!golferRecords[gmsk].partners[partnerKey]) {
              golferRecords[gmsk].partners[partnerKey] = {
                firstName: partnerMatch?.firstName || '',
                lastName: partnerMatch?.lastName || '',
                rounds: {},
                record: { losses: 0, wins: 0, ties: 0 },
              }
            }

            // Ensure the round record exists
            if (!golferRecords[gmsk].partners[partnerKey].rounds[round]) {
              golferRecords[gmsk].partners[partnerKey].rounds[round] = {
                record: { losses: 0, wins: 0, ties: 0 },
              }
            }

            const record = golferRecords[gmsk].partners[partnerKey].record
            const record_round = golferRecords[gmsk].partners[partnerKey].rounds[round].record

            // Update the record based on the result
            if (winner_ms === teamNumber) {
              record.wins += 1
              record_round.wins += 1
            } else if (!winner_ms) {
              record.ties += 1
              record_round.ties += 1
            } else {
              record.losses += 1
              record_round.losses += 1
            }
          }

          const opponents_existing = _.cloneDeep(golferRecords[gmsk].opponents)

          if (_.isEmpty(opponents_existing)) {
            // If no existing opponents, just assign the new opponents
            golferRecords[gmsk].opponents = opponents_match;
          } else {
            // Iterate over each opponent in opponents_match
            _.forEach(opponents_match, (opponent_match, matchOpponentKey) => {
              // Check if the opponent already exists
              const existingOpponent = opponents_existing[matchOpponentKey];

              if (existingOpponent) {
                // Merge rounds if opponent exists
                const _glfOpp = golferRecords[gmsk].opponents[matchOpponentKey];
                golferRecords[gmsk].opponents[matchOpponentKey].rounds = [
                  ..._glfOpp.rounds,
                  ...opponent_match.rounds
                ];
                golferRecords[gmsk].opponents[matchOpponentKey].matchStatuses = [
                  ..._glfOpp.matchStatuses,
                  ...opponent_match.matchStatuses
                ];
              } else {
                // Add new opponent if not present in existing opponents
                golferRecords[gmsk].opponents[matchOpponentKey] = opponent_match;
              }
            });
          }
        })
      })

      _.forEach(golferRecords, (gr, grk) => {
        gr.points = gr.wins + gr.ties * .5
      })

      golferRecordsSorted = _.orderBy(golferRecords, ['points'], 'desc')
    }
  }

  return { golferRecords, golferRecordsSorted }
}

const getHoleWinnerTimeline = (round) => {
  // Flatten
  const events = _.flatMap(round, (match, matchKey) =>
    _.map(match.holeWinners, (holeWinner, holeNumber) => ({
      matchKey,
      holeNumber: Number(holeNumber),
      winningTeam: holeWinner.winningTeam,
      createdAt: holeWinner.createdAt
    }))
  );

  // Sort by createdAt
  return _.sortBy(events, "createdAt");
};

const archiveTournment = async (state) => {
  const { database_fns, pathViews, golfTournament, details, matches } = state
  const { _itemKey } = golfTournament ?? {}
  const _golfTournament = _.cloneDeep(golfTournament)
  const { golfers } = details ?? {}
  const _golfers = _.cloneDeep(golfers)
  removeFromObject(_golfTournament, _ignoreKeys)
  removeFromObjects(_golfers, _ignoreKeys)
  removeFromObjects(_golfers, _dateKeys)


  dataFix.removeAllEmpties(details)
  dataFix.removeAllEmpties(matches)

  const _archiveRef = createRefPath_event(pathViews, ['golfTournaments_archive', _itemKey])
  const _detailsRef = createRefPath(['details', 'details'], _archiveRef)
  const _matchesRef = createRefPath(['details', 'matches'], _archiveRef)

  try {
    await database_fns.set_doc(_archiveRef, _golfTournament)
    await database_fns.set_doc(_detailsRef, details)
    await database_fns.set_doc(_matchesRef, matches)
  } catch (error) {
    console.log('error', error)
  }
}

export const golfTournamentHelpers = {
  ammendLineupsWithGolfers,
  ammendMatchGolfers,
  ammendMatchTeamGolfers,
  ammendTournament_matchesStatus,
  ammendTournamentGolfers,
  archiveTournment,
  changeTournanemtGolfer,
  clearRoundMatchesInDatabase,
  clearRoundResultsInDatabase,
  clearTournamentResultsInDatabase,
  createRoundMatchesInDatabase,
  getAllMatches: getAllMatches_golf,
  getGolferResults,
  getGolfTournamentWithDetails,
  getHoleWinnerTimeline,
  getPar,
  getSeletedTeamGolfers,
  getTournamentCourses,
  initGolfTournamentData,
  removeMatchScore,
  roundColor,
  updateGolfTournament,
  updateGolfTournamentDetails,
  updateGolfTournamentResults,
  updateMatchScore,
}